import React, { useEffect, useState } from 'react';
import { Marker } from '@react-google-maps/api';
import { Loader } from '@googlemaps/js-api-loader';
import PropTypes from 'prop-types';
import { Cards } from '../../../../Dashboard/components/appoiments/style';

const ContentMap = ({ userCoordinates, showOnlyInitialPosition = false, onlyCoords }) => {
  const [map, setMap] = useState(null);

  const initialPosition = onlyCoords
    ? {
        lat: onlyCoords.value.markerCoords.latitude,
        lng: onlyCoords.value.markerCoords.longitude,
      }
    : userCoordinates.length > 0
    ? {
        lat: userCoordinates[0].coordinates[1],
        lng: userCoordinates[0].coordinates[0],
      }
    : { lat: 6.3084807267484475, lng: -75.5045725572256 };

  const center = { ...initialPosition };

  useEffect(() => {
    const loader = new Loader({
      apiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
      version: 'weekly',
    });

    loader.load().then((google) => {
      setMap(
        new google.maps.Map(document.getElementById('map'), {
          center,
          zoom: onlyCoords ? 15 : 10,
        }),
      );
    });
  }, []);

  const renderInitialMarker = () =>
    map && initialPosition && <Marker key="initial" position={initialPosition} map={map} />;

  const renderUserMarkers = () =>
    map &&
    !showOnlyInitialPosition &&
    userCoordinates.map((user) => (
      <Marker key={user.id} position={{ lat: user.coordinates[1], lng: user.coordinates[0] }} map={map} />
    ));

  return (
    <>
      {onlyCoords ? (
        <Cards headless bordered={false}>
          <div id="map" style={{ width: '100%', height: '300px', padding: '0px' }} />
          {renderInitialMarker()}
          {renderUserMarkers()}
        </Cards>
      ) : (
        <Cards headless bodyStyle={{ minHeight: '400px' }}>
          <div id="map" style={{ width: '100%', height: '600px' }} />
          {renderInitialMarker()}
          {renderUserMarkers()}
        </Cards>
      )}
    </>
  );
};

export default ContentMap;

ContentMap.propTypes = {
  userCoordinates: PropTypes.arrayOf(PropTypes.object),
  showOnlyInitialPosition: PropTypes.bool,
  onlyCoords: PropTypes.object,
};
